import * as React from "react";
function SvgToneNeutral(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M32 16A16 16 0 1116 0a16 16 0 0116 16zm-22-5a2 2 0 102 2 2 2 0 00-2-2zm12 0a2 2 0 102 2 2 2 0 00-2-2zm1 12a1 1 0 00-1-1H10a1 1 0 000 2h12a1 1 0 001-1z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgToneNeutral);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
